
import { marked } from 'marked'
import YAML from 'yaml'

import URLUtil from 'zunzun/flyutil/url.mjs'

const e_doc_text = document.querySelector("div.content_block div.doc_text");
const load_page = async (page_name, section_id) => {
  try {
    display_loading_overlay();
    if (!section_id) section_id = "";
    console.log(`LOAD PAGE ${page_name}`);
    window.history.pushState(null, null, `?page=${page_name}#${section_id}`);
    const doc_yaml = await fetch(`res/doc/${page_name}`).then(res => res.text());
    e_doc_text.innerHTML = marked.parse(doc_yaml);

    const linked_headings = e_doc_text.querySelectorAll("h1, h2, h3, h4, h5, h6");
    for (let lh of linked_headings) {
      const link = document.createElement("a");
      link.href = `?page=${page_name}#${lh.id}`;
      link.classList.add("head-link");
      link.target = "_blank";
      link.innerHTML = "&#10497;";

      lh.appendChild(link);
    }


    if (section_id.length > 0) window.scrollTo(0, document.getElementById(section_id).offsetTop)
    hide_loading_overlay();
  } catch (e) {
    console.error(e.stack);
  }
}


class ContentsNode {
  constructor(node, parent_element) {
    if (typeof node.title !== "string") {
      throw new Error(`Invalid doc contents node: ${JSON.stringify(node, null, 2)}`);
      return;
    }

    this.element = document.createElement("div");
    this.element.classList.add("doc_contents_node");



    if (
      typeof node.sub_directory === "string" &&
      Array.isArray(node.sub_contents)
    ) {
      const e_title = document.createElement("h4");
      e_title.innerText = node.title;
      this.element.append(e_title);
      for (let sub_node of node.sub_contents) {
        if (sub_node.fname) {
          sub_node.fname = node.sub_directory+'/'+sub_node.fname;
        }
        if (sub_node.sub_directory) {
          sub_node.sub_directory = node.sub_directory+'/'+sub_node.sub_directory;
        }
        new ContentsNode(sub_node, this.element);
      }
    } else if (typeof node.fname === "string") {
      const e_title = document.createElement("a");
      e_title.innerText = node.title;


      console.log(`LINK to ${e_title.href}`);

      e_title.addEventListener("click", async (evt) => {
        try {
          evt.preventDefault();

          await load_page(node.fname);



//        URLUtil.set_parameter("doc", node.fname);
        

        } catch (e) {
          console.error(e.stack);
        }
      });

      this.element.append(e_title);
    } else {
      throw new Error(`Invalid doc contents node: ${JSON.stringify(node, null, 2)}`);
      return;
    }

    parent_element.append(this.element);
  }
}

const e_doc_contents = document.querySelector("div.content_block div.doc_contents");

const e_contents_show_hide = document.querySelector("div.content_block button.show_or_hide");

e_contents_show_hide.addEventListener("click", (e) => {
  if (e_doc_contents.classList.contains("hidden")) {
    e_contents_show_hide.style = ``;
    e_doc_text.classList.remove("expanded");
    e_doc_contents.classList.remove("hidden");
  } else {
    e_contents_show_hide.style = `transform: scale(-1, 1); left: 5px;`;
    e_doc_text.classList.add("expanded");
    e_doc_contents.classList.add("hidden");
  }
});

(async () => {
  try {
    const doc_contents = YAML.parse(await fetch(
      `res/doc/contents.yaml`
    ).then(res => res.text()));


    const default_page = URLUtil.get_parameter('page', window.location.href) || doc_contents[0].fname;
    const default_section = window.location.href.split("#")[1];
    await load_page(default_page, default_section)

    console.log(doc_contents);
    for (let node of doc_contents) {
      new ContentsNode(node, e_doc_contents);
    }

    hide_loading_overlay();
  } catch (e) {
    console.error(e);
  }
})();
